import React from 'react';
import { TabTypes } from './ui/TabConstants';
import DescriptionCollapsible from './ui/DescriptionCollapsible';
import DescriptionTabs from './ui/DescriptionTabs';
import DescriptionTable from './ui/DescriptionTable';
import DescriptionDocuments from './ui/DescriptionDocuments';
import EditorString from '../EditorString';
import DescriptionFaq from './ui/DescriptionFaq';
import { translate } from '../../Services/translation';


const getIcon = (id) => {
  switch (id) {
    case TabTypes.TechnicalData:
    case TabTypes.ProductInformation:
    case TabTypes.ProductSpecification:
      return 'Document';
    case TabTypes.Documents:
      return 'Pdf';
    case TabTypes.DeliveryInfo:
      return 'Delivery';
    case TabTypes.Faq:
      return 'Question-Rounded';
    default:
      return 'Info';
  }
};

const getContent = (product, id, fields) => {


  switch (id) {
    case TabTypes.TechnicalData:
    case TabTypes.ProductInformation:
    case TabTypes.ProductSpecification:
      const updatedFields = [
        ...fields,
        {
          id: 'artno',
          name: translate('product.table.bin'),
          ref: undefined,
          value: product.id,
          unit: undefined, // or the appropriate unit if applicable
        }
      ];
      return <DescriptionTable fields={updatedFields} />;
    case TabTypes.Documents:
      return <DescriptionDocuments documents={fields} />;
    case TabTypes.DeliveryInfo:
      return <EditorString value={product.genericDeliveryInformation.value} />;
    case TabTypes.Faq:
      return (
        <div className="faq-tabs">
          {product.genericFaqItems.map((item, idx) => (
            <DescriptionFaq key={`faq-tab-` + idx} {...item} />
          ))}
        </div>
      );
    default:
      return <></>;
  }
};

const ProductPageDescription = ({ product, productFields }) => {
  const fieldsWithFaq = [
    ...productFields,
    ...(product.genericFaqItems != null
      ? [
          {
            groupId: TabTypes.Faq,
            name: 'FAQ',
            productFields: [], // No fields needed here since FAQ is in product.faqItems
          },
        ]
      : []),
  ];
  return (
    <>
      {!!fieldsWithFaq.length && (
        <>
          <DescriptionTabs
            product={product}
            productFields={fieldsWithFaq}
            getIcon={getIcon}
            getContent={getContent}
          />
          <div className="description-collapsibles">
            {fieldsWithFaq.map((fieldGroup) => (
              <DescriptionCollapsible
                key={`collapsible-${fieldGroup.groupId}`}
                label={fieldGroup.name}
                content={getContent(
                  product,
                  fieldGroup.groupId,
                  fieldGroup.productFields
                )}
                icon={getIcon(fieldGroup.groupId)}
              />
            ))}
          </div>
        </>
      )}
      {product.genericProductDescription && (
        <EditorString
          value={product.genericProductDescription.value}
          className="product-page__generic-description"
        />
      )}
    </>
  );
};

export default ProductPageDescription;
